import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import MemberBar from './MemberBar.js';
import { useFdocOthers, useFdocSelf } from '../../config/fdocs.config.js';
import { useQueryResourceMemberPermissions } from '../../../permission/queries/useQueryResourceMemberPermissions.js';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { ButtonShare } from '../../../permission/components/ButtonShare.js';
import { useQueryUserInfo } from '../../../user/queries/useQueryUserInfo.js';

const MemberBarResourceWithLiveBlockBase = ({ resourceId, onOpenShareModal, className, barColorScheme, isPublicShared, hideShareButton, renderShareButtonOutside }) => {
  const others = useFdocOthers();
  const self = useFdocSelf();
  const { data: user } = useQueryUserInfo();
  const liveMembers = useMemo(() => {
    const members = others.slice(0);
    if (self) members.push(self);
    return members;
  }, [
    others,
    self
  ]);
  const { membersWithRole } = useQueryResourceMemberPermissions({
    resourceId
  });
  const { isMobileView } = useResponsive();
  const otherLiveMembers = others.filter((member) => member.id !== user?.id);
  const hasMultipleMembers = membersWithRole.length > 1 || otherLiveMembers.length > 0;
  const shouldRenderShareButtonOutside = renderShareButtonOutside && !isMobileView && !hasMultipleMembers && !isPublicShared;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      shouldRenderShareButtonOutside && onOpenShareModal && /* @__PURE__ */ jsx(ButtonShare, {
        shape: void 0,
        onClick: onOpenShareModal,
        text: "Share"
      }, "member-share-button"),
      /* @__PURE__ */ jsx(MemberBar, {
        members: membersWithRole,
        liveMembers,
        hideWhenAlone: true,
        maxMembers: isMobileView ? 1 : 3,
        onClickOpenSharingSettings: shouldRenderShareButtonOutside ? void 0 : onOpenShareModal,
        className,
        resourceId,
        itemType: "resource",
        barColorScheme,
        anonId: self?.id,
        isPublicShared,
        hideShareButton
      })
    ]
  });
};

export { MemberBarResourceWithLiveBlockBase as default };
//# sourceMappingURL=MemberBarResourceWithLiveBlockBase.js.map
